import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-create-folder',
  templateUrl: './create-folder.page.html',
  styleUrls: ['./create-folder.page.scss'],
})
export class CreateFolderPage implements OnInit {
  //This is the folder that we are currently in
  @Input() current_folder: any = null;
  
  folder_info = {
    guid: '0',
    title: '',
    visible_to_client: true
  }

  constructor(private modalController: ModalController,private apiService: ApiService,public globalService: GlobalService) { }

  ngOnInit() {
    this.folder_info.guid = this.current_folder.guid;
    // A folder inside an internal (not visible to client) folder must also be internal - never let a
    // visible folder exist underneath a hidden one, so this isn't just a default, it's locked (see
    // the disabled checkbox below).
    if (!this.IsParentVisibleToClient()) this.folder_info.visible_to_client = false;
  }

  // visible_to_client can come back as a real boolean or as a "1"/"0" string depending on the
  // endpoint (see explorer.component.ts's IsFolderVisibleToClient for the same convention).
  IsParentVisibleToClient(): boolean {
    return this.current_folder?.visible_to_client === true || this.current_folder?.visible_to_client === 1 || this.current_folder?.visible_to_client === '1';
  }

  // "Visible to client" (and therefore "Internal Only") only means anything for a folder that
  // actually lives under a client/company's own folder tree - a firm-internal folder has no client
  // to hide it from in the first place (see explorer.component.ts's IsClientScopedFolder).
  IsClientScopedFolder(): boolean {
    return !!(this.current_folder?.client_guid || this.current_folder?.company_guid);
  }

  // Bound to the checkbox as its own property (rather than binding directly to
  // folder_info.visible_to_client) so the label/checked-state reads naturally as "Internal Only" while
  // folder_info.visible_to_client stays the single source of truth actually posted to the backend.
  get internal_only(): boolean {
    return !this.folder_info.visible_to_client;
  }
  set internal_only(value: boolean) {
    this.folder_info.visible_to_client = !value;
  }


  async Create(){
    let return_data: any = await this.apiService.post('folders',this.folder_info);
    if(return_data.success) {
      this.modalController.dismiss(return_data.data);
    }
    this.globalService.presentToastMessage(return_data.message,return_data.success);

  }
  async Close(){
    this.modalController.dismiss();
  }

  error_message = '';
  has_error = false;

  ngDoCheck() {
    this.CheckIfFormIsValid();
  }

  CheckIfFormIsValid() {
    this.error_message = '';
    let has_error = false;
    const messages: string[] = [];


    // Folder title required
    if (this.folder_info.title.trim() === '') {
      messages.push('Folder title is required.');
      has_error = true;
    }

    // Write to string for tooltip or display
    this.error_message = messages.join('<br>');
    this.has_error = has_error;
  }

}
